import axios from 'axios'

import { ref } from 'vue'

export default function useNonPaginatedRegisters() {
  const all_registers_api_path = ref('')

  const listRegisters = async () => {
    return new Promise((resolve, reject) => {
      axios
        .get(all_registers_api_path.value)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  return {
    all_registers_api_path,
    listRegisters,
  }
}
